var currentEnv = process.env.REACT_APP_ENV;
var featureFlag = function featureFlag() {
  var hideInEnvironment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemToDisplay = arguments.length > 1 ? arguments[1] : undefined;
  var replacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (hideInEnvironment.includes(currentEnv)) {
    return replacement;
  } else {
    return itemToDisplay;
  }
};

export { featureFlag as default };
